import log from '$$log';

export default {
  data() {
    return {
      isLoadedRequiredData: false,
    };
  },
  async created() {
    const timer = log.time('ganttLoadRequiredData');

    if (this.$store.getters.isBase) {
      const ganttIds = this.$store.getters.getActiveGanttIdsByRoute;

      const tColumns = log.time('ganttLoadRequiredData.dynamicLoadValues');
      await this.$store.dispatch('columns/dynamicLoadValues', { ganttIds });
      tColumns.end();
    }

    this.isLoadedRequiredData = true;
    timer.end();
  },
};
